import React, { useState } from 'react';
import { HandIcon, MailIcon, SparklesIcon } from 'lucide-react';
import { ArchiveTile } from '../../components/archive/ArchiveTile';
import { ArchiveDetail } from '../../components/archive/ArchiveDetail';
import { InitialAvatar } from '../../components/InitialAvatar';
import { ARCHIVE_ITEMS } from '../../data/archive';
import type { ArchiveItem } from '../../data/archive';
import { VOICES_ISSUES } from '../../data/voices';
export function Voices() {
  const [issueId, setIssueId] = useState(VOICES_ISSUES[0].id);
  const [openItem, setOpenItem] = useState<ArchiveItem | null>(null);
  const issue = VOICES_ISSUES.find(entry => entry.id === issueId) ?? VOICES_ISSUES[0];
  const backIssues = VOICES_ISSUES.filter(entry => entry.id !== issue.id);
  const featured = issue.featured.map(id => ARCHIVE_ITEMS.find(item => item.id === id)).filter((item): item is ArchiveItem => Boolean(item));
  return <div className="min-h-full bg-card" data-id="element-846" data-mp="3tevbdds2t2p0">
      {/* Same off-white band as People and Archive. */}
      <div className="border-b border-rule bg-canvas" data-id="element-847" data-mp="3u0zvne9r1plk">
        <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 px-4 py-6 sm:px-6" data-id="element-848" data-mp="2t5afgfyptn6">
          <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2" data-id="element-849" data-mp="3kz0gkriaovl9">
            <div className="flex flex-wrap items-baseline gap-x-3" data-id="element-850" data-mp="3l1ctgq974frg">
              <h1 className="text-section-heading font-semibold text-ink" data-id="element-851" data-mp="3pwjrbhfsaq8g">Voices</h1>
              <p className="text-small text-ink-muted" data-id="element-852" data-mp="3b85pn9u3t7th">
                The monthly letter, as it went out by email
              </p>
            </div>
            <span className="inline-flex shrink-0 items-center gap-2 rounded-pill border border-rule px-3.5 py-1.5 text-small text-ink-muted" data-id="element-853" data-mp="328ipssh0wa2j">
              <MailIcon aria-hidden="true" className="h-4 w-4" data-id="element-854" data-mp="36b5l53cwkd4h" />
              You receive this
            </span>
          </div>
        </div>
      </div>

      {/* THE ISSUE — one at a time, read like a letter. */}
      <article className="mx-auto w-full max-w-3xl px-4 py-8 sm:px-6" data-id="element-855" data-mp="2x8wcyk53wvu9">
        <header className="flex flex-col gap-4 border-b border-rule pb-6" data-id="element-856" data-mp="12th3qgmnaq6h">
          <span className="flex items-center gap-2 text-eyebrow-caption font-semibold uppercase text-ink-muted" data-id="element-857" data-mp="y2r13b5lt1fh">
            <span aria-hidden="true" className="h-px w-5 bg-highlight" data-id="element-858" data-mp="u0dvqnurr5j8" />
            {issue.month}
          </span>
          <h2 className="text-display font-semibold text-ink" data-id="element-859" data-mp="p2vkurx6yg8l">{issue.title}</h2>
          <div className="flex items-center gap-3" data-id="element-860" data-mp="1lslafiqps7uz">
            <InitialAvatar name={issue.author.name} size={40} data-id="element-861" data-mp="1lra5hflj8u2a" />
            <span className="flex flex-col" data-id="element-862" data-mp="1hrja0yl29prf">
              <span className="text-body font-medium text-ink" data-id="element-863" data-mp="1honc3a97r12z">{issue.author.name}</span>
              <span className="text-small text-ink-muted" data-id="element-864" data-mp="1cths4gzdfwhj">{issue.author.role}</span>
            </span>
          </div>
        </header>

        <div className="flex flex-col gap-5 py-6" data-id="element-865" data-mp="1byk8bauj5cn">
          {issue.paragraphs.map(paragraph => <p key={paragraph.slice(0, 32)} className="text-body leading-relaxed text-ink" data-id="element-866" data-mp="3sisyjauka6bo">
              {paragraph}
            </p>)}
        </div>

        {featured.length > 0 ? <section aria-labelledby="featured" className="border-t border-rule pt-6" data-id="element-867" data-mp="3ndfmjylbspe9">
            <h3 id="featured" className="text-heading font-semibold text-ink" data-id="element-868" data-mp="3scs8mh4dhsfs">
              What we&apos;re pointing at this month
            </h3>
            <ul className="mt-4 columns-1 gap-4 sm:columns-2 [&>li]:mb-4" data-id="element-869" data-mp="ywai8jtpmay">
              {featured.map(item => <ArchiveTile key={item.id} item={item} onOpen={setOpenItem} data-id="element-870" data-mp="4zg5p6ku6fug" />)}
            </ul>
          </section> : null}

        {issue.updates.length > 0 ? <section aria-labelledby="issue-updates" className="mt-6 flex flex-col gap-4 rounded-card border border-rule bg-canvas p-5" data-id="element-871" data-mp="ez6yn3tr0msf">
            <h3 id="issue-updates" className="flex items-center gap-2 text-heading font-semibold text-ink" data-id="element-872" data-mp="2gq0m0d9za8az">
              <SparklesIcon aria-hidden="true" className="h-4 w-4 text-primary-text" data-id="element-873" data-mp="2lqfx0y6sf3ps" />
              New in the portal
            </h3>
            <ul className="flex flex-col divide-y divide-rule" data-id="element-874" data-mp="b18agdpf0xrs">
              {issue.updates.map(update => <li key={update.title} className="flex flex-col gap-1 py-3 first:pt-0 last:pb-0" data-id="element-875" data-mp="p0zlc5kmxy1k">
                  <span className="text-body font-medium text-ink" data-id="element-876" data-mp="k1elzu1jznob">{update.title}</span>
                  <span className="text-small text-ink-muted" data-id="element-877" data-mp="3sgybqj30mnym">{update.body}</span>
                </li>)}
            </ul>
          </section> : null}

        <p className="mt-6 border-t border-rule pt-6 text-body italic text-ink-muted" data-id="element-878" data-mp="3oe1nabqsnxmr">
          {issue.signoff}
        </p>
        <p className="mt-1 text-small text-ink-muted" data-id="element-879" data-mp="1beyvcp9winj">
          — {issue.author.name}, {issue.author.role.toLowerCase()}
        </p>
      </article>

      {/* BACK ISSUES */}
      <section aria-labelledby="back-issues" className="border-t border-rule bg-canvas" data-id="element-880" data-mp="39om1la64eidx">
        <div className="mx-auto w-full max-w-3xl px-4 py-8 sm:px-6" data-id="element-881" data-mp="34pswa50zlxou">
          <h2 id="back-issues" className="text-heading font-semibold text-ink" data-id="element-882" data-mp="1k91l7fqzvcdu">
            Past issues
          </h2>
          <ul className="mt-4 flex flex-col divide-y divide-rule border-t border-rule" data-id="element-883" data-mp="1p1up61en2gov">
            {backIssues.map(entry => <li key={entry.id} data-id="element-884" data-mp="1g7zu5m78e6my">
                <button type="button" onClick={() => {
              setIssueId(entry.id);
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            }} className="flex w-full flex-col gap-0.5 py-4 text-left hover:bg-card focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-885" data-mp="1g9awrioxx8ch">
                  <span className="text-small text-ink-muted" data-id="element-886" data-mp="1ywwfv1okbqtk">{entry.month}</span>
                  <span className="text-body font-medium text-ink" data-id="element-887" data-mp="iiwfxqppw16b">{entry.title}</span>
                  <span className="text-small text-ink-muted" data-id="element-888" data-mp="nklvnjnvx30q">
                    {entry.author.name} · {entry.paragraphs.length}{' '}
                    {entry.paragraphs.length === 1 ? 'note' : 'notes'}
                  </span>
                </button>
              </li>)}
          </ul>
          <p className="mt-5 text-small text-ink-muted" data-id="element-889" data-mp="3qt8sd3mms7as">
            Voices goes out on the first of the month. You can stop receiving it from your
            settings and still read every issue here.
          </p>

          <div className="mt-6 flex flex-col gap-3 rounded-card border border-rule bg-card p-5 sm:flex-row sm:items-center sm:justify-between" data-id="element-890" data-mp="3gxnlar2pggu6">
            <div className="flex max-w-xl flex-col gap-1" data-id="element-891" data-mp="37ve97wrsgfeo">
              <p className="text-body font-medium text-ink" data-id="element-892" data-mp="37vxu9mcqjjwx">
                Want to help put this together?
              </p>
              <p className="text-small text-ink-muted" data-id="element-893" data-mp="164axt5a2qwt2">
                The archive group is four volunteers and a scanner. No commitment, no schedule.
              </p>
            </div>
            <a href="#volunteer" className="inline-flex min-h-tap shrink-0 items-center gap-2 rounded-pill bg-primary px-5 text-small font-medium text-on-primary hover:bg-primary-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2" data-id="element-894" data-mp="113djj3s6qmwu">
              <HandIcon aria-hidden="true" className="h-4 w-4" data-id="element-895" data-mp="1ne548hilvryx" />
              Get in touch
            </a>
          </div>
        </div>
      </section>

      <ArchiveDetail item={openItem} onClose={() => setOpenItem(null)} data-id="element-896" data-mp="prpqnqtavegn" />
    </div>;
}